import React from 'react';
import Footer from '../components/Footer.js';
import Navbar from '../components/navbar/Navbar.js';
import CalculatorPumpText from '../components/CalculatorPumpText.js';
import Banner from '../components/Banner.js';
import { useSEO } from '../components/CustomHook';

const CalculatorP = () => {
    useSEO(
        "Förderrechner Wärmepumpe - Kostenlose Förderung berechnen",
        "Berechnen Sie kostenlos Ihre Wärmepumpen-Förderung. Erhalten Sie sofort eine detaillierte Übersicht über verfügbare Förderungen und sparen Sie Kosten.",
        "Förderrechner Wärmepumpe, Wärmepumpe Förderung, Förderung berechnen, BEG Förderung, Wärmepumpe Kosten",
        "/videos/foerder.mp4"
    );

    return (
        <>
            <Navbar />
            <Banner
                videoSrc="/videos/foerder.mp4"
                title="Förderrechner Wärmepumpe"
                subtitle="Berechnen Sie Ihre Förderung"
                description="Erhalten Sie sofort eine detaillierte Übersicht über verfügbare Förderungen für Ihre Wärmepumpe. Sparen Sie Kosten mit unseren Förderprogrammen."
            />
            <CalculatorPumpText />
            <Footer />
        </>
    )
}

export default CalculatorP;

